import { Box, Flex, Stack } from '@chakra-ui/react';
import danSignature from '@public/assets/dan-signature.png';
import dan from '@public/headshots/dan.jpeg';
import Image from 'next/image';
import generateSitemap from 'sitemap/generateSitemap';
import DefaultLayout from '../components/layout/layout/DefaultLayout';
import Investors from '../components/pages/about/fsm/Investors';
import Team from '../components/pages/about/fsm/Team';
import CallUs from '../components/pages/index/fsm/CallUs';
import News from '../components/pages/index/fsm/News';
import Body1 from '../components/typography/Body1';
import Eyebrow from '../components/typography/Eyebrow';
import Header from '../components/typography/Header';

export async function getStaticProps() {
  generateSitemap();
  return { props: {} };
}

const WhoIsDanielPetkevich = () => {
  return (
    <DefaultLayout>
      <Box bg="teal" p={[3, 3, 8, 12]}>
        <Stack py={[10, 10, 16, 20]} px={[4, 4, 8, 8]} bg="darkBackground" gap={[4, 4, 8, 8]} alignItems="center">
          <Header as="h2" textAlign="center">
            Who is Daniel Petkevich?
          </Header>
          <Image src={dan} width={160} height={160} alt="Dan Petkevich" />
          <Stack w="100%" maxW="780px" spacing={[6, 6, 6, 8]}>
            <Body1 textStyle="wizard">
              Hi, I'm Dan, the founder and CEO of Fair Square Medicare. If you landed on this page, you probably
              received my letter about Medicare, and you're also probably in the same situation my parents were back in
              2019.
            </Body1>
            <Body1 textStyle="wizard">
              I watched them talk to one pushy agent after another, and that led me to starting Fair Square – the
              Medicare brokerage I wish my parents had.
            </Body1>
            <Body1 textStyle="wizard">
              At Fair Square, we create a personalized plan that advises you on when to enroll in Medicare Parts A and
              B, and what Medigap or Medicare Advantage plan to choose.
            </Body1>
            <Body1 textStyle="wizard">
              Our goal is to find you the most comprehensive plan for your needs and budget.
            </Body1>
            <Body1 textStyle="wizard">It's the way Medicare should be.</Body1>
            <Flex w="100%" justifyContent="center" gap={8} alignItems="center" pt={[2, 2, 4, 12]}>
              <Stack spacing={0}>
                <Box w="100px">
                  <Image src={danSignature} alt="Dan Petkevich Signature" />
                </Box>
                <Body1>Dan Petkevich</Body1>
                <Eyebrow>Founder & CEO</Eyebrow>
              </Stack>
            </Flex>
          </Stack>
        </Stack>
      </Box>
      <Team />
      <Investors />
      <News />
      <Box bg="white">
        <CallUs />
      </Box>
    </DefaultLayout>
  );
};

export default WhoIsDanielPetkevich;
